import iSessions from '../features/auth/Sessions';
import { FamlaServices } from '../services';
import InterviewAccessService from '../services/InterviewAccessService';
import { clearAnalysisDraft } from './analysisDraftStorage';
import { login } from '../stores/slices/authSlice';
import store, { persistor } from '../stores/store';

export type SwitchActiveCompanyOptions = {
    /** Full page navigation after Redux + persist sync */
    redirectTo?: string;
    /** Reload current URL when no redirectTo (ignored if redirectTo is set) */
    reload?: boolean;
};

/**
 * Switch the active company on the server session, refresh Redux auth from /auth/me,
 * flush redux-persist, then optionally redirect or reload.
 */
export async function switchActiveCompany(
    companyId: string,
    accessToken: string,
    options: SwitchActiveCompanyOptions = {},
): Promise<boolean> {
    const targetId = companyId?.trim();
    if (!targetId || !accessToken) {
        return false;
    }

    try {
        const putResponse = await FamlaServices(
            'api_host',
            '/session/',
            'PUT',
            { company_id: targetId, interview_id: '' },
            accessToken,
        );
        if (putResponse.status !== 200) {
            return false;
        }

        const meResponse = await FamlaServices(
            'api_host',
            '/auth/me',
            'GET',
            '',
            accessToken,
        );
        if (meResponse.status !== 200 || !meResponse.body?.data) {
            return false;
        }

        const session = meResponse.body.data as iSessions;
        store.dispatch(
            login({
                token: accessToken,
                session,
                user: session.user,
            }),
        );

        await persistor.flush();
        InterviewAccessService.clearCache();
        clearAnalysisDraft();

        if (options.redirectTo) {
            window.location.replace(options.redirectTo);
        } else if (options.reload) {
            window.location.reload();
        }

        return true;
    } catch {
        return false;
    }
}
